"use client";

import React from "react";
import { ArrowUpRight, Box, Target } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "growth",
  title: "Growth",
  description: "Strategic scaling, market positioning, and sustainable revenue generation tailored for early-stage and mid-market ventures.",
  icon: ArrowUpRight
}, {
  id: "ops",
  title: "Ops",
  description: "Building robust operational frameworks, streamlining workflows, and implementing systems that support rapid, stable scaling.",
  icon: Box
}, {
  id: "execution",
  title: "Execution",
  description: "Translating high-level strategy into tangible, day-to-day actions with operator-level precision and accountability.",
  icon: Target
}];
export default function OperatorLedConsulting() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="operator-led-consulting" className="dark bg-background text-foreground py-24 md:py-32 px-6 md:px-12 lg:px-24">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-16 md:mb-24">
          <h2 className="font-default text-3xl md:text-5xl font-semibold tracking-tight text-foreground mb-6">
            Operator-Led Consulting
          </h2>
          <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
            We provide strategic support for small to mid-sized businesses needing operator-level growth, operations, and execution expertise. Not an agency. Not done-for-you. We build with you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={service.id} data-index={index} className="group flex flex-col p-8 md:p-10 border border-transparent hover:border-border hover:bg-white/[0.02] transition-all duration-300 cursor-default rounded-sm">
                <div className="mb-8">
                  <Icon className="w-10 h-10 text-primary stroke-[1]" aria-hidden="true" />
                </div>
                <h3 className="font-default text-2xl font-semibold text-foreground mb-4 tracking-tight">
                  {service.title}
                </h3>
                <p className="font-default text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}